/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Feature_Unlimited_CreditsInputs */

const en_landing_pricing_feature_unlimited_credits = /** @type {(inputs: Landing_Pricing_Feature_Unlimited_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited credits`)
};

const zh_landing_pricing_feature_unlimited_credits = /** @type {(inputs: Landing_Pricing_Feature_Unlimited_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无限积分`)
};

/**
* | output |
* | --- |
* | "Unlimited credits" |
*
* @param {Landing_Pricing_Feature_Unlimited_CreditsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_feature_unlimited_credits = /** @type {((inputs?: Landing_Pricing_Feature_Unlimited_CreditsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Feature_Unlimited_CreditsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_feature_unlimited_credits(inputs)
	return zh_landing_pricing_feature_unlimited_credits(inputs)
});
export { landing_pricing_feature_unlimited_credits as "landing.pricing.feature_unlimited_credits" }